$(document).ready(function()
{

    $('.gfield_description span.is-fa').click(function(e) 
    {
        $(this).siblings( ".polite-instructions" ).toggleClass("active");
    });

});